import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@mui/material';

interface DividerProps extends MuiDividerProps {
  spacing?: number;
}

export const Divider = ({ spacing = 2, ...props }: DividerProps) => (
  <MuiDivider sx={{ my: spacing, ...props.sx }} {...props} />
);
